<template>
    <div>
        <h1>ss</h1>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>